import { ExternalLink, Globe } from "lucide-react";
import { T } from "@/i18n";

const TEXT = "Per consultare le offerte aggiornate in tempo reale e prenotare voli e hotel con link diretti, clicca qui o visita la versione online del viaggio su tripsaver.it";

export const OnlineBox = ({ url }) => (
  <div data-testid="pdf-online-box" className="print-only print-break rounded-3xl border-2 border-emerald-600 bg-emerald-50 p-8">
    <div className="flex items-start gap-5">
      <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-emerald-600 text-white"><Globe className="h-6 w-6" /></span>
      <div>
        <p className="font-display text-xl font-semibold text-gray-900"><T>Prenota con i prezzi aggiornati</T></p>
        <p className="mt-2 leading-relaxed text-gray-700"><T>{TEXT}</T></p>
        <a href={url} className="mt-5 inline-flex items-center gap-2 rounded-full bg-emerald-600 px-6 py-3 font-semibold text-white">
          <T>Apri il viaggio online</T> <ExternalLink className="h-4 w-4" />
        </a>
        <p className="mt-3 break-all text-xs text-emerald-800">{url}</p>
      </div>
    </div>
  </div>
);

export const PrintPageFooter = ({ url }) => (
  <a href={url} data-testid="pdf-page-footer" className="print-page-footer items-center gap-4 rounded-xl border border-emerald-600 bg-emerald-50 px-4 py-2.5 text-gray-800 no-underline">
    <span className="flex-1 text-[10px] leading-snug"><T>{TEXT}</T></span>
    <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-emerald-600 px-4 py-1.5 text-[11px] font-semibold text-white">
      <T>Clicca qui</T> <ExternalLink className="h-3 w-3" />
    </span>
  </a>
);
